import React from "react";
import "./AccountClosure.scss";
import { Button, Input, Modal } from "antd";
import { IUserInfo } from "@utils/Interfaces";
import userApi from "services/UserApi";
import Helpers from "utils/Helpers";
import { useAuth } from "contexts/AuthContext";
import { errorLog } from "logging";
import SearchSetting from "@components/SearchSetting/SearchSetting";

const AccountClosure: React.FC<{ user: IUserInfo }> = ({ user }) => {
  const [isOpenConfirm, setIsOpenConfirm] = React.useState(false);
  const [displayNameToConfirm, setDisplayNameToConfirm] = React.useState("");
  const { logOut } = useAuth();

  const handleDeleteAccount = async () => {
    if (displayNameToConfirm !== user.display_name) {
      Helpers.notification.warning("Please enter correct display name");
      return;
    }
    const payload = {
      display_name: displayNameToConfirm,
    };
    try {
      const response = await userApi.deleteAccount(payload);
      if (response.status === 200) {
        logOut();
        Helpers.redirect("/auth");
      }
    } catch (error) {
      Helpers.notification.error("Something wrong in server");
      errorLog("AccountClosure.tsx - handleDeleteAccount", error);
    }
  };

  return (
    <div className="AccountClosure">
      <SearchSetting />
      <div className="title">Account Closure</div>
      <p>
        Once you delete your account, it cannot be recovered. Alternatively, you
        can deactivate your account temporarily and come back anytime. Please
        consider this carefully.
      </p>
      <div className="delete-group">
        <Button
          className="deactivate-btn"
          //onClick={() => setIsOpenConfirm(true)}
        >
          Deactivate Account
        </Button>
        <Button className="delete-btn" onClick={() => setIsOpenConfirm(true)}>
          Delete Account
        </Button>
      </div>

      <Modal
        title="Confirm"
        open={isOpenConfirm}
        onOk={handleDeleteAccount}
        className="confirm-popup"
        onCancel={() => setIsOpenConfirm(false)}
        okText="Delete"
        cancelButtonProps={{ type: "text" }}
      >
        <p>
          Once you delete your account, this action cannot be reversed. Are you
          sure you want to continue? Enter <b>{user.display_name}</b> to
          confirm.
        </p>
        <Input
          value={displayNameToConfirm}
          onChange={(e) => setDisplayNameToConfirm(e.target.value)}
          variant="filled"
          size="large"
          placeholder="Your profile name"
        />
      </Modal>
    </div>
  );
};

export default AccountClosure;
